import React from 'react';
import { useSettings } from '../../../hooks/admin/useSettings';
import { SettingsCard } from './SettingsCard';

export function GeneralSettings() {
  const { settings, updateSettings, isLoading } = useSettings('general');

  return (
    <SettingsCard
      title="General Settings"
      description="Configure basic platform settings"
      isLoading={isLoading}
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-white mb-2">
            Platform Name
          </label>
          <input
            type="text"
            value={settings?.platformName || ''}
            onChange={(e) => updateSettings({ platformName: e.target.value })}
            className="input w-full"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-white mb-2">
            Support Email
          </label>
          <input
            type="email"
            value={settings?.supportEmail || ''}
            onChange={(e) => updateSettings({ supportEmail: e.target.value })}
            className="input w-full"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-white mb-2">
            Default Language
          </label>
          <select
            value={settings?.defaultLanguage || 'en'}
            onChange={(e) => updateSettings({ defaultLanguage: e.target.value })}
            className="input w-full"
          >
            <option value="en">English</option>
            <option value="es">Spanish</option>
            <option value="fr">French</option>
          </select>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="maintenance-mode"
              checked={settings?.maintenanceMode || false}
              onChange={(e) => updateSettings({ maintenanceMode: e.target.checked })}
              className="rounded border-gray-700 text-accent-green focus:ring-accent-green bg-background-dark"
            />
            <label htmlFor="maintenance-mode" className="ml-2 text-sm text-white">
              Maintenance Mode
            </label>
          </div>
        </div>
      </div>
    </SettingsCard>
  );
}